import { NavLink } from "react-router-dom";

/** One nav entry, two related pages (meeting feedback: don't pack the
 * nav bar) — Jobs and Cost Codes cross-link through this segmented tab. */
export default function JobsCostCodesTabs() {
  const cls = ({ isActive }) =>
    `px-3.5 py-2 rounded-lg text-[12.5px] font-bold ${isActive ? "bg-sky-500 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`;
  return (
    <div className="flex gap-1.5 mb-4" data-testid="jobs-costcodes-tabs">
      <NavLink to="/contractor/jobs" end className={cls}>Jobs</NavLink>
      <NavLink to="/contractor/cost-codes" className={cls}>Cost Codes</NavLink>
    </div>
  );
}
